module.exports = __webpack_public_path__ + "img/amx-19.bd5ea5d5.webp";